import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';

// routers
import Login from './login';
import Home from './home';
import user from './user';
import News from './news';
import Events from './events';
import Order from './order';
import Topic from './topic';
import bigData from './bigData';
import gis from './gis';
import gisMap from './gisMap';
import Gdod from './gdod';
import Products from './products';
import Software from './software';
import browseData from './browseData';
import MetaData from './metaData';
import Characteristic from './characteristic';
import Excellent from './excellent';
import Voyage from './voyage';
import ProjectServices from './projectServices';
import ProjectExchange from './projectExchange';
import BigBayCity from './bigBayCity';
import DataExchangeService from './dataExchangeService';
// import MetaDataPersonal from './metaDataPersonal';
import VoyageUserApply from './voyageApply';
import ScientificStory from './scientificStory';
import MetaDataPool from './metaDataPool';
import PersonalExchange from './personalExchange';
import PaperExchange from './paperExchange';
import ArticleExchange from './articleExchange';
import VoyageExchange from './voyageExchange';
import ThematicSelectedCharacteristicHotspot from './thematicSelectedCharacteristicHotspot';
import BoutiqueImages from './boutiqueImages';
import MapData from './mapData';
import StationObservationExchange from './stationObservationExchange';
import StationObservation from './stationObservation';
import FishIdentification from './fishIdentification';
import Article from './article';
import BuoySubmarineExchange from './buoySubmarineExchange';
import BuoySubmarine from './buoySubmarine';
import Duty from './duty';
import KnowledgeGrap from './knowledgeGrap';
import DataCenter from './dataCenter';
import Xarea from './x-area';
import MetaDataOrder from './metaDataOrder';
import HelpCenter from './helpCenter';
import RemittanceVoucher from './remittanceVoucher';
import VoyagePhysicalOcean from './voyagePhysicalOcean';
import DataCatalog from './dataCatalog';
import Laboratory from './laboratory';

// view
const Layout = () => import('Components/v-layout');
const gdodLayout = () => import('Components/v-gdod-layout');
const NotFoundError = () => import('Views/not-found-error');

Vue.use(Router);

const Routes = [
  ...Login,
  ...Home,
  ...MapData,
  ...ScientificStory,
  ...FishIdentification,
  ...KnowledgeGrap,
  ...Xarea,
  {
    path: '/',
    component: Layout,
    children: [
      ...user,
      ...News,
      ...Events,
      ...Order,
      ...Topic,
      ...gisMap,
      ...bigData,
      ...gis,
      ...Products,
      ...Software,
      ...browseData,
      // ...Plugin,
      ...MetaData,
      ...Characteristic,
      ...Excellent,
      ...Voyage,
      ...ProjectServices,
      ...ProjectExchange,
      ...BigBayCity,
      ...DataExchangeService,
      // ...MetaDataPersonal,
      ...VoyageUserApply,
      ...MetaDataPool,
      ...PersonalExchange,
      ...PaperExchange,
      ...ArticleExchange,
      ...VoyageExchange,
      ...ThematicSelectedCharacteristicHotspot,
      ...BoutiqueImages,
      ...StationObservationExchange,
      ...StationObservation,
      ...Article,
      ...BuoySubmarineExchange,
      ...BuoySubmarine,
      ...Duty,
      ...DataCenter,
      ...MetaDataOrder,
      ...RemittanceVoucher,
      ...HelpCenter,
      ...VoyagePhysicalOcean,
      ...DataCatalog,
      ...Laboratory,
    ],
  },
  {
    path: '/gdod',
    component: gdodLayout,
    children: [
      ...Gdod,
    ],
  },
  { path: '*', name: 'NotFoundError', component: NotFoundError },
];

const router = new Router({
  mode: 'history',
  routes: Routes,
});

router.beforeEach((to, from, next) => {
  // eslint-disable-next-line
  if (_hmt) {
    if (to.path) {
      // eslint-disable-next-line
      _hmt.push(['_trackPageview', to.fullPath]);
    }
  }
  // eslint-disable-next-line
  store.dispatch('currentMenu', to.path);
  // 设置每个页面的title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

/* 重写路由push方法 解决console输出"定位到相同路径"的警告" */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js